import React from 'react';
import { Container } from 'reactstrap';
import { DashboardPageHeader, ComingSoonCard, DeptToolsGrid, DeptReportsGrid } from '../../Components/Common/DashboardKit';

/**
 * Shukla module landing page.
 *
 * Owner (2026-10-05): the department pages list the modules the team uses and the KPI
 * reports that matter to it (DeptLandingSections); each card shows only when the person
 * may open it. India accounts see only their own modules here, by the same gates.
 * The route is gated by dept.shukla in allRoutes.js.
 */
const TOOLS = ["displayBoards", "di", "mafia", "dmsAll", "epoSnApprovals", "cr", "tasks"];
const REPORTS = ["shukla-sales-dashboard", "shukla-sales-rental", "aged-receivables-shukla", "summary-otd"];

const Shukla = () => {
    document.title = "SSW Technologies Dashboard";

    return (
        <React.Fragment>
            <div className="page-content">
                <Container fluid>
                    <DashboardPageHeader
                        icon="ri-building-2-line"
                        eyebrow="Shukla Medical"
                        title="Shukla"
                        subtitle="Tools and reports for the Shukla Medical line"
                        tone="default"
                        breadcrumb={[
                            { label: "Dashboards", to: "/" },
                            { label: "Shukla" },
                        ]}
                    />

                    <DeptToolsGrid
                        ids={TOOLS}
                        title="Shukla tools"
                        description="Boards, inspection, specs, documents and SN approvals"
                        icon="ri-building-2-line"
                    />
                    <DeptReportsGrid ids={REPORTS} />

                    <ComingSoonCard
                        compact
                        icon="ri-building-2-line"
                        title="More for Shukla later"
                        message="Ideas for later: Shukla production reports, component traceability and lot release. The cards above are live today."
                        tone="primary"
                    />
                </Container>
            </div>
        </React.Fragment>
    );
};

export default Shukla;
